import React, { useEffect } from 'react';
import styled from 'styled-components';
import starIcon from '../../assets/star_icon.svg';

const RatingContainer = styled.div`
  .op-5 {
    opacity: 0.4;
  }
`;

const Rating = ({ totalRating = 5, currentRating = 0 }) => {
  useEffect(() => {}, []);

  return (
    <RatingContainer>
      {[...Array(totalRating)].map((item, index) => {
        const ratingInd = index + 1;
        return (
          <label>
            <img src={starIcon} className={`${ratingInd < currentRating || ratingInd === currentRating ? '' : 'op-5'}`} />
          </label>
        );
      })}
    </RatingContainer>
  );
};

export default Rating;
